<template>
    <div class="tab-wrap">
        <div v-for="(item, index) in list" :key="index" :class="{'active': activeIndex == index}" @click="changeTab(index)" >{{item}}</div>
    </div>
</template>
<script>
export default {
    name: 'TabHegu',
    props:{
        activeIndex: {
            type: Number,
            default: 0,
        },
        list: {
            type: Array,
            default: () => [],
        },
    },
    methods:{
        changeTab(index){
            this.$emit('changeTab', index)
        },
    },
}
</script>
<style lang="scss" scoped>
.tab-wrap{
    width: 100%;
    height: 100%;
    display:flex;
    align-items: center;
    justify-content: space-between;
    div{
        flex:1;
        height: 100%;
        background-color: rgba(1, 88, 120, 0.4);
        border: 0.1rem solid rgba(48, 136, 122, 0.4);
        border-radius: 2rem;
        font-size: 2.4rem;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(125, 255, 255, 0.4);
        display:flex;
        align-items: center;
        justify-content: center;
        margin-left:2rem;
    }
    div:first-child{
        margin-left:0;
    }
    .active{
        color: #7DFFFF;
        background-image:url("/theme/default/img/tab_bg.png");
        background-size: 100% 100%;
        border: none;
        background-color: unset;
        border-radius: unset;
        background-repeat: no-repeat;
    }
}
</style>